// Stránky investičních bytů – zvýraznění aktivní položky menu sekcí (pruh pod hlavičkou).
// Markup: includes/template-parts/redesign/reality/subnav.php – odkazy `.re-subnav__link` na kotvy
// sekcí. Aktivní je poslední sekce, jejíž horní hrana už přejela pod lepivou hlavičku (výška
// v --rd-header-h, počítá assets/js/redesign/header.js); na konci stránky poslední sekce, nad
// první sekcí žádná. Stav nese `aria-current="location"`, barvu dává assets/scss/reality/_subnav.scss.

export default function initRealitySubnav() {
  const links = [...document.querySelectorAll('.re-subnav__link[href^="#"]')];
  if (!links.length) {
    return;
  }

  // Menu je v DOM dvakrát (pruh a burger panel) – sekce se berou jednou, v pořadí na stránce.
  const ids = [...new Set(links.map((link) => link.hash.slice(1)))];
  const sections = ids
    .map((id) => document.getElementById(id))
    .filter(Boolean)
    .sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
  if (!sections.length) {
    return;
  }

  let current = null;
  let ticking = false;

  const headerHeight = () =>
    parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--rd-header-h')) || 0;

  const update = () => {
    ticking = false;
    const line = headerHeight() + 16;
    const atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;

    let active = null;
    if (atBottom) {
      active = sections[sections.length - 1];
    } else {
      sections.forEach((section) => {
        if (section.getBoundingClientRect().top <= line) {
          active = section;
        }
      });
    }

    const id = active ? active.id : null;
    if (id === current) {
      return;
    }
    current = id;
    links.forEach((link) => {
      if (link.hash.slice(1) === id) {
        link.setAttribute('aria-current', 'location');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  };

  const schedule = () => {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  update();
}
